module.exports = __webpack_public_path__ + "img/expovina_05.9d1ffe2c.jpg";